module.exports = __webpack_public_path__ + "static/media/winSmall120_1.c9d91832.png";